// extracted by mini-css-extract-plugin
export default {"pageContainer":"CommonOperationScreen_pageContainer__vjI1U","footer":"CommonOperationScreen_footer__5hf1V"};